import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../utils/axios';

// Login shows its own UI/redirect → suppress the generic global "success" toast
// on login; keep global ERROR for failed sign-in.
const SN = { skipNotify: 'success' };

export const login = createAsyncThunk(
  'auth/login',
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await axios.post('/admin/auth/login', credentials, SN);
      const { token, user } = response.data;
      
      // Store token in local storage
      localStorage.setItem('admin_token', token);
      localStorage.setItem('admin_user', JSON.stringify(user));
      
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.msg || 'Login failed. Please check your credentials.'
      );
    }
  }
);

const parseJwt = (token) => {
  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch (e) {
    return null;
  }
};

const token = localStorage.getItem('admin_token');
let isValidToken = false;
let user = JSON.parse(localStorage.getItem('admin_user')) || null;

if (token) {
  const decodedJwt = parseJwt(token);
  if (decodedJwt && decodedJwt.exp * 1000 > Date.now()) {
    isValidToken = true;
  } else {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_user');
    user = null;
  }
}

const initialState = {
  user: user,
  token: isValidToken ? token : null,
  isAuthenticated: isValidToken,
  isLoading: false,
  error: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logout: (state) => {
      localStorage.removeItem('admin_token');
      localStorage.removeItem('admin_user');
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;
      state.error = null;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isAuthenticated = true;
        state.user = action.payload.user;
        state.token = action.payload.token;
      })
      .addCase(login.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { logout, clearError } = authSlice.actions;

export default authSlice.reducer;
